import { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'

import ModalProvider from 'contexts/ModalProvider'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import TripDrawer from 'tripPlanner/components/GenericDrawer/TripDrawer'
import TripDrawerHeaderTitle from 'tripPlanner/components/GenericDrawer/TripDrawerHeaderTitle'
import cartPanelMessages from '../components/cartPanelMessages'
import CartPanelContainer from '../containers/CartPanelContainer'
import { useMobileCartPanelState } from '../hooks/useMobileCartPanelState'

interface TripChatMobileCartPanelModalProps {
  onClose: () => void
}

function TripChatMobileCartPanelModal({ onClose }: TripChatMobileCartPanelModalProps) {
  const intl = useIntl()
  const modalElement = useModalElementContext()
  const isOpen = modalElement.open !== false
  const title = intl.formatMessage(cartPanelMessages.title)
  const header = useMemo(() => (
    <TripDrawerHeaderTitle title={title} />
  ), [title])

  return (
    <TripDrawer
      isOpen={isOpen}
      direction="right-to-left"
      header={header}
      data-testid="trip-chat-mobile-cart-panel-layer"
      onClose={onClose}
    >
      <CartPanelContainer
        onClose={onClose}
        presentation="embedded"
      />
    </TripDrawer>
  )
}

interface TripChatMobileCartPanelHostProps {
  closeSignal?: number
  onCartOpenChange?: (isOpen: boolean) => void
}

function TripChatMobileCartPanelHostContent({ closeSignal, onCartOpenChange }: TripChatMobileCartPanelHostProps) {
  const createCartModal = useCallback((onClose: () => void) => (
    <TripChatMobileCartPanelModal onClose={onClose} />
  ), [])

  useMobileCartPanelState(createCartModal, closeSignal, onCartOpenChange)

  return null
}

function TripChatMobileCartPanelHost(props: TripChatMobileCartPanelHostProps) {
  return (
    <ModalProvider>
      <TripChatMobileCartPanelHostContent {...props} />
    </ModalProvider>
  )
}

export default TripChatMobileCartPanelHost
